import { getDuration } from "common";
import pluralize from "pluralize";
import React from "react";
import { NoTranslate } from "@/components/Common/NoTranslate";

interface TimePickerTextProps {
    timeInMinutes: number;
}

export const TimePickerText = ({ timeInMinutes }: TimePickerTextProps) => {
    const duration = getDuration(timeInMinutes);
    return duration.value === 0 ? (
        <span>after</span>
    ) : (
        <>
            <span>
                within <NoTranslate>{duration.value} </NoTranslate>
            </span>
            <span>{pluralize(duration.unit, duration.value)} of</span>
        </>
    );
};
